export const IntranetSagePaySlip = {
    path: '/intranet_sage_pay_slips',
    name: 'intranet_sage_pay_slips',
    component: () => import('@/views/Intranet/IntranetSagePaySlipPage.vue'),
    children: [
        {
            path: '/intranet_sage_pay_slips/upload',
            name: 'intranet_sage_pay_slips.upload',
            component: () => import('@/views/Integration/Sage/PaySlip/Form/SagePaySlipUploadForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/intranet_sage_pay_slips/view/:id',
            name: 'intranet_sage_pay_slips.view',
            component: () => import('@/views/Integration/Sage/PaySlip/Form/SagePaySlipForm.vue'),
            props: {viewAction: true}
        },
    ]
}